import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale, LinearScale, BarElement,
    Title, Tooltip, Legend,
    PointElement,
    LineElement,
} from 'chart.js';
import { Bar,Line } from 'react-chartjs-2';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: false,
            position: 'top',
        },
        title: {
            display: true,
            text: 'Grafica de Calor',
            color: '#fff'
        },
    },
    scales: {
        y: {
            beginAtZero: true,
            max: 0.01,
        }
    }
};
export var dataAux;

export const optionsl = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Grafica de logs motos',
        color: '#000'
      },
    },
  };
function GraficoCallCenter(props) {
    const { datos, maxValue } = props;
    const getColor = (valor) => {
        var P = (valor / maxValue);
        var R = Math.round(0xFF * (P));
        var G = Math.round(0xFF * (1 - P));
        var B = 0x00;
        return '#' + R.toString(16).padStart(2, '0') + G.toString(16).padStart(2, '0') + B.toString(16).padStart(2, '0');
    }
    const labels = datos.map((item) => item.hora);
    const data = {
        labels,
        datasets: [
            {
                label: "Promedio",
                data: datos.map((item) => item.promedio),
                backgroundColor: datos.map((item) => getColor(item.promedio)),
                barPercentage: 1.0,
                categoryPercentage: 1.0,
                max: 1,
            },
        ],
    }
    return (
        <>
            <div className='bg-dark w-100 mb-2' style={{height:'40vh'}}>
                {true && <Bar options={options} data={data} width='100vh' updateMode='resize' />}
            </div>
            <div className='bg-light w-100 ' style={{height:'40vh'}}>
                {true && <Line options={optionsl} data={data} width='100vh' updateMode='resize'/>}
            </div>
        </>
    )
}

export default GraficoCallCenter